"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var profile_api_1 = require("@l2p/profile-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var DetailBox_1 = require("../../DetailBox");
var ValidUntil_1 = require("../../ValidUntil");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Congratulations = function (_a) {
    var _b, _c, _d, _e;
    var closeModal = _a.closeModal, bonus = _a.bonus;
    var t = (0, next_intl_1.useTranslations)('translation');
    var data = (0, swr_hooks_1.useBalance)().data;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var maxBet = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        var maxBet = (_c = (_b = (_a = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _a === void 0 ? void 0 : _a.constraints) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.type === profile_api_1.BonusConstraintType.MaxBet; })) === null || _c === void 0 ? void 0 : _c.maxBet;
        return (_d = maxBet === null || maxBet === void 0 ? void 0 : maxBet.find(function (item) { return item.currency === (bonus === null || bonus === void 0 ? void 0 : bonus.currency); })) === null || _d === void 0 ? void 0 : _d.amount;
    }, [bonus === null || bonus === void 0 ? void 0 : bonus.currency, (_b = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _b === void 0 ? void 0 : _b.constraints]);
    if (!data || !bonus)
        return null;
    return (react_1.default.createElement(ui_components_1.Modal, { width: "450px", height: "auto", onClose: closeModal, padding: Object.keys(breakpoints).length > 0 && breakpoints.mobile
            ? '25px 15px 10px'
            : '40px 39px 20px', saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                react_1.default.createElement("div", null,
                    t('congratulations'),
                    "!")),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description },
                react_1.default.createElement("div", null, t('bonusSuccessfullyApplied'))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusContainer },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, "".concat((0, apps_shared_1.getCurrencySymbol)(bonus === null || bonus === void 0 ? void 0 : bonus.currency), " ").concat(Number(bonus === null || bonus === void 0 ? void 0 : bonus.startBalance).toFixed(2))),
                    react_1.default.createElement(ValidUntil_1.ValidUntil, { bonus: bonus })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusTitle }, (_c = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _c === void 0 ? void 0 : _c.title),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusDetails },
                    react_1.default.createElement(DetailBox_1.DetailBox, null,
                        t('maxBet'),
                        react_1.default.createElement("span", null, maxBet ? (react_1.default.createElement(react_1.default.Fragment, null,
                            (0, apps_shared_1.getCurrencySymbol)(bonus === null || bonus === void 0 ? void 0 : bonus.currency),
                            Number(maxBet).toFixed(2))) : ('N/A'))),
                    react_1.default.createElement(DetailBox_1.DetailBox, null,
                        t('wager'),
                        react_1.default.createElement("span", null, ((_d = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _d === void 0 ? void 0 : _d.wageringMultiplier)
                            ? "x".concat((_e = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _e === void 0 ? void 0 : _e.wageringMultiplier)
                            : '-')))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonsContainer },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", maxWidth: "300px", onClick: closeModal }, t('ok'))))));
};
exports.default = Congratulations;
